import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import { Form, Button } from "react-bootstrap";
import ProfileSaveChoices from "./components/ProfileSaveChoices";
import { GlobalState } from "contexts/GlobalState";
import { fieldsForm, schema } from "./fields";
import useForm from "hooks/useForm";

const url = "https://www.tfaforms.com/responses/processor";

import "./style.scss";


const namePattern = new RegExp(/^[a-z\u0590-\u05fe \-]{2,20}$/i);
const formOrder = ["first_name", "last_name", "phone", "email", "degree", "faculty", "checked", "subject"]
const formMapping = { email: "tfa_35", phone: "tfa_36", degree: "tfa_41", faculty: "tfa_47", subject: "tfa_37", degree_number: "tfa_62", faculty_number: "tfa_63", interested_number: "tfa_64", interested: "tfa_38" };

const degreeIdMapping = {
  "תואר ראשון": 1,
  'ד"ר לרפואה': 1,
  "תואר שני": 2,
  "לימודי תעודה": 7,
  "First": 1,
  "Md": 1,
  "Second": 2,
  "Teaching Diploma": 7
};
export const InterestedStudiesForm = (props) => {

  const ProfileSaveChoicesRef = useRef();
  const form = useRef();
  const [globalUser, setGlobalUser] = GlobalState("user");
  const [facultyId, setFacultyId] = useState("");
  const [degreeId, setDegreeId] = useState("");
  const [disabledButton, setDisabledButton] = useState(false);
  const faculties = props.values.nodes.faculty;
  let degrees = props.values.terms.twr;
  //temp solution of removing several degree options. (lines 36-37)
  const degreesToRemove = ["תואר שלישי", "תעודת הוראה", "ד\"\ר לרפואה"];
  degrees = degrees.filter(degree => !degreesToRemove.includes(degree.name));
  //change degrees order
  const a = degrees[0];
  degrees = degrees.slice(1);
  degrees.push(a);
  const { formik, renderElementsForm, renderElement, handleLoadData } = useForm(
    {
      fieldsForm,
      schema,
      onSubmit: handleSubmit,
    }
  );

  useEffect(() => {
    if (globalUser?.user?.registrationFormChoices) {
      handleLoadData(globalUser?.user?.registrationFormChoices);
    }
  }, [globalUser]);

  //focus on first error (if there is one) when pressing submit
  useEffect(() => {
    if (formik.isSubmitting) {
      for (let control of formOrder) {
        if (formik.errors[control] || !document.getElementsByName(control)[0]?.value) {
          document.getElementsByName(control)[0]?.focus();
          break;
        }
      }
    }
  }, [formik.isSubmitting])

  useEffect(() => {
    for (let faculty of faculties) {
      if (faculty.name === formik.values.faculty) {
        setFacultyId(faculty.fid);
        break;
      }
    }
  }, [formik.values.faculty])

  useEffect(() => {
    if (degreeIdMapping[formik.values.degree]) {
      setDegreeId(degreeIdMapping[formik.values.degree]);
    } else {
      setDegreeId(0);
    }
  }, [formik.values.degree])

  useEffect(() => {
    if (props.values.bi_data) {
      schema.fields.degree = null;
      schema.fields.faculty = null;
    }
  }, [schema])

  async function sendEmail(postBody, emailTo) {

    const fullName = postBody['tfa_33'];
    const emailUser = postBody['tfa_35'];
    const phoneNumber = postBody['tfa_36'];
    const fieldOfStudy = postBody['tfa_38'];
    const text = `שם: ${fullName}\nטלפון: ${phoneNumber}\nאמייל: ${emailUser}`;
    const title = ` מתענין בלימודים עבור ${fieldOfStudy} מאתר המועמדים`

    const response = await fetch(`${window.location.origin}/sendEmail/sendEmailForProgram`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },

      body: JSON.stringify({
        subject: title,
        text: text,
        email: emailTo
      })
    });

    return response.status;

  }
  async function handleSubmit() {

    ProfileSaveChoicesRef.current.setShow(true);
    const data = new FormData(form.current);
    //create a JSON from the formData fields

    const postBody = {};
    for (let pair of data.entries()) {
      if (formMapping[pair[0]]) {
        postBody[formMapping[pair[0]]] = pair[1];
      } else {
        postBody[pair[0]] = pair[1];
      }
    }


    setDisabledButton(true);
    const requestMetadata = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(postBody)
    };
    formik.resetForm();
    const response = await fetch(`${window.location.origin}/salesForce/sendSalesForce?url=responses/processor`, requestMetadata);
    const emailTo = props?.values?.bi_data?.field_interested_studies_email;
    if (emailTo) {
      const sendEmailRes = await sendEmail(postBody, emailTo);
    }
    return false;
  };

  const changeSelect = (() => {
    if (document.querySelector('#tfa_41')) {
      !Utils.isMobile() ? document.querySelector('#tfa_41').value != "" && (document.querySelector('.label-select').style.fontSize = "0.75rem") :
        document.querySelector('#tfa_41').value != "" && (document.querySelector('.label-select').style.fontSize = "1.2rem");
    }
    if (document.querySelector('#tfa_47')) {
      !Utils.isMobile() ? document.querySelector('#tfa_47').value != "" && (document.querySelector('.second-select').style.fontSize = "0.75rem") :
        document.querySelector('#tfa_47').value != "" && (document.querySelector('.second-select').style.fontSize = "1.2rem");
    }
    return formik.handleChange;
  });

  const fieldsHomePage = (() => {
    return (
      <>
        <Form.Group
          controlId="tfa_41" >
          <Form.Label className="ph label-select">{props.values.degree} </Form.Label>
          <Form.Control
            as="select"
            value={formik.values.degree}
            onChange={changeSelect()}
            onBlur={formik.handleBlur}
            name="degree"
            aria-label={props.values.degree}
            aria-required="true"
            aria-invalid={formik.touched.degree && formik.errors.degree}
            aria-describedby="degreeError" >
            <option key="1234"></option>
            {degrees.map((degree) => (
              <option key={degree.tid} value={degree.name}>
                {degree.name}
              </option>
            ))}
          </Form.Control>
          {formik.touched.degree && formik.errors.degree ? (
            <span id="degreeError" className="text-danger">{props.values[formik.errors["degree"]]}</span>
          ) : null
          }
        </Form.Group>
        <Form.Group
          controlId="tfa_47">
          <Form.Label className="ph second-select">{props.values.faculty} </Form.Label>
          <Form.Control
            as="select"
            onChange={changeSelect()}
            value={formik.values.faculty}
            onBlur={formik.handleBlur}
            isInvalid={!!formik.errors.faculty}
            name="faculty"
            aria-label={props.values.faculty}
            aria-required="true"
            aria-invalid={formik.touched.faculty && formik.errors.faculty}
            aria-describedby="facultyError"  >
            <option key="1235" value=""></option>
            <option
              key="1236"
              value={props.values.didnt_decide} >
              {props.values.didnt_decide}
            </option>
            {faculties.map((faculty) => (
              <option key={faculty.nid} value={faculty.name}>
                {faculty.name}
              </option>
            ))}
          </Form.Control>
          {formik.touched.faculty && formik.errors.faculty ? (
            <span id="facultyError" className="text-danger">{props.values[formik.errors["faculty"]]}</span>
          ) : null
          }
        </Form.Group>
        <Form.Group>
          <Form.Control type="hidden" value={degreeId} name="tfa_62" />
          <Form.Control type="hidden" value={facultyId} name="tfa_63" />
          <Form.Control type="hidden" value="" name="tfa_64" />
        </Form.Group>
      </>
    )
  })

  const fieldsProgramPage = (() => {
    return (
      <div>
        <Form.Group controlId="tfa_62"> <Form.Control type="hidden" value={props?.values?.bi_data.field_bi_degree_number} name="degree_number" /></Form.Group>
        <Form.Group controlId="tfa_41"> <Form.Control type="hidden" value={props?.values?.bi_data.field_bi_degree_description} name="degree" /></Form.Group>
        <Form.Group controlId="tfa_63"> <Form.Control type="hidden" value={props?.values?.bi_data.field_bi_faculty_number} name="faculty_number" /></Form.Group>
        <Form.Group controlId="tfa_47"><Form.Control type="hidden" value={props?.values?.bi_data.field_bi_faculty_description} name="faculty" /></Form.Group>
        <Form.Group controlId="tfa_64"><Form.Control type="hidden" value={props?.values?.bi_data.field_bi_interested_number} name="interested_number" /></Form.Group>
        <Form.Group controlId="tfa_38"><Form.Control type="hidden" value={props?.values?.bi_data.field_bi_interested_description} name="interested" /></Form.Group>
      </div>
    )
  })
  return (
    <div className="form-interested-study">
      {disabledButton && props?.values?.isDetailsForm ? (
        <div className="send-message"
          dangerouslySetInnerHTML={{
            __html: props?.values?.sendMessage || '<div></div>'
          }}
        ></div>
      ) : (
        <>
          {props?.values?.isDetailsForm && (
            <div>
              <h1 className="regitration-title">{props?.values?.title}</h1>
              <span className="form-title">{props?.values?.form_title}</span>
            </div>
          )}
          <Form
            name="myForm"
            action="https://www.tfaforms.com/responses/processor"
            onSubmit={formik.handleSubmit}
            method="post"
            ref={form}
          >
            <div className="full-name">
              <Form.Group controlId="first_name">
                <Form.Control
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  maxLength={20}
                  name="first_name"
                  placeholder=" "
                  aria-label={props.values.first_name}
                  aria-required="true"
                  aria-invalid={formik.touched.first_name && formik.errors.first_name}
                  aria-describedby="firstNameError"
                  value={formik.values.first_name}
                  className="first-name"
                />
                <Form.Label className="ph">{props.values.first_name} </Form.Label>
                {formik.touched.first_name && formik.errors.first_name ? (
                  <span id="firstNameError" className="text-danger">{props.values[formik.errors["first_name"]]}</span>
                ) : null
                }
              </Form.Group>

              <Form.Group controlId="last_name">
                <Form.Control
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  maxLength={20}
                  name="last_name"
                  placeholder=" "
                  aria-label={props.values.last_name}
                  aria-required="true"
                  aria-invalid={formik.touched.last_name && formik.errors.last_name}
                  aria-describedby="lastNameError"
                  value={formik.values.last_name}
                  className="first-name"
                />
                <Form.Label className="ph">{props.values.last_name} </Form.Label>
                {formik.touched.last_name && formik.errors.last_name ? (
                  <span id="lastNameError" className="text-danger">{props.values[formik.errors["last_name"]]}</span>
                ) : null
                }
              </Form.Group>

              <Form.Group controlId="tfa_33">
                <Form.Control
                  type="hidden"
                  value={`${formik.values.first_name} ${formik.values.last_name}`}
                  name="tfa_33"
                />
              </Form.Group>

              <Form.Group controlId="tfa_37">
                <Form.Control
                  type="hidden"
                  value={!props.values.bi_data ? `${props.values.newRegistrationSite}-${formik.values.degree}-${formik.values.faculty}` :
                    `${props.values.newRegistrationSite}-${props.values.bi_data.field_bi_degree_description}-${props.values.bi_data.field_bi_faculty_description}-${props.values.bi_data.field_bi_interested_description}`}
                  name="tfa_37"
                />
              </Form.Group>
            </div>
            <Form.Group controlId="tfa_36">
              <Form.Control
                type="tel"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder=" "
                aria-label={props.values.phone}
                aria-required="true"
                aria-invalid={formik.touched.phone && formik.errors.phone}
                aria-describedby="phoneError"
                name="phone"
                value={formik.values.phone}
              />
              <Form.Label className="ph">{props.values.phone} </Form.Label>
              {formik.touched.phone && formik.errors.phone ? (
                <span id="phoneError" className="text-danger">{props.values[formik.errors["phone"]]}</span>
              ) : null
              }
            </Form.Group>

            <Form.Group controlId="tfa_35">
              <Form.Control
                type="email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                aria-describedby="emailHelp"
                name="email"
                placeholder=" "
                aria-label={props.values.email}
                aria-required="true"
                aria-invalid={formik.touched.email && formik.errors.email}
                aria-describedby="emailError"
                value={formik.values.email}
              />
              <Form.Label className="ph">{props.values.email} </Form.Label>
              {formik.touched.email && formik.errors.email ? (
                <span id="emailError" className="text-danger">{props.values[formik.errors["email"]]}</span>
              ) : null
              }
            </Form.Group>

            {!props.values.bi_data ?
              fieldsHomePage() : fieldsProgramPage()}
            <div className="submit-btn">
              <Form.Group controlId="checked">
                <Form.Check
                  type="checkbox"
                  label={`${props.values.checkbox} `}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  checked={formik.values.checked}
                  aria-label={props.values.checkbox}
                  aria-required="true"
                  name="checked"
                />
                {formik.touched.checked && formik.errors.checked ? (
                  <span className="text-danger checkbox" aria-label={props.values[formik.errors["checked"]]}>{props.values[formik.errors["checked"]]}</span>
                ) : null
                }

              </Form.Group>
              <Form.Group>
                <Button aria-label={props.values.submit} variant="primary" type="submit" aria-haspopup="true" disabled={disabledButton}>
                  {props.values.submit}
                </Button>
                <span className="required-field">{props.values.required_field}</span>
              </Form.Group>
            </div>
            <Form.Group>
              <Form.Control type="hidden" value="" name="tfa_34" />
              {/* <Form.Control type="hidden" value="" name="tfa_37" /> */}
              {/* <Form.Control type="hidden" value="" name="tfa_38" /> faculty */}
              <Form.Control type="hidden" value="" name="tfa_39" />
              {/* <Form.Control type="hidden" value="" name="tfa_41" />  degree */}
              <Form.Control type="hidden" value="" name="tfa_43" />
              <Form.Control type="hidden" value="" name="tfa_44" />
              <Form.Control type="hidden" value="tfa_46" name="tfa_45" />
              {/* <Form.Control type="hidden" value="" name="tfa_47" /> */}
              <Form.Control type="hidden" value="" name="tfa_48" />
              <Form.Control type="hidden" value="" name="tfa_49" />
              <Form.Control type="hidden" value="" name="tfa_51" />
              <Form.Control
                type="hidden"
                value={formik.values.checked ? "tfa_56" : "tfa_57"}
                name="tfa_52"
              />
              {/* checked*/}

              <Form.Control type="hidden" value="" name="tfa_58" />
              <Form.Control type="hidden" value="" name="tfa_59" />
              <Form.Control type="hidden" value="7014G000001coYl" name="tfa_61" />
              <Form.Control type="hidden" value="4808324" name="tfa_dbFormId" />
              <Form.Control type="hidden" value="" name="tfa_dbResponseId" />
              <Form.Control
                type="hidden"
                value="185ce51c138eb3c98621e85cf7a6618a"
                name="tfa_dbControl"
              />
              <Form.Control type="hidden" value="2" name="tfa_dbVersionId" />
              <Form.Control type="hidden" value="" name="tfa_switchedoff" />
            </Form.Group>
          </Form>
        </>
      )}
      <ProfileSaveChoices
        ref={ProfileSaveChoicesRef}
        labels={props.values}
        registrationFormChoices={formik.values}
        isDetailsForm={props?.values?.isDetailsForm}
      ></ProfileSaveChoices>
    </div>
  );
};
